import { buttonClasses, SxProps } from '@mui/material'

export interface CounterType {
  counterWrapper: SxProps
  button: SxProps
  count: SxProps
}

export const styles: CounterType = {
  counterWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
  },
  button: {
    display: 'flex',
    padding: 0,
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 36,
    height: 36,
    color: 'text.secondary',

    [`${buttonClasses.disabled}`]: {
      color: 'button.textDisabledSecondary',
    },
  },
  count: {
    typography: 'textSm',
    color: 'text.textSecondary700',
    width: 15,
    textAlign: 'center',
  },
}
